import React, { useState } from "react";
import { useSnackbar } from "notistack";
import CircularProgress from "@mui/material/CircularProgress";
import CustomMUIInput from "../inputsFields/CostomMuiInputs";
import {
  change_client_password_api,
  reset_pop_up_api_for_clients_candidates,
} from "../../DAL/partner/partners";
import { useIds } from "../../hook/AdminContext";
import InfoIcon from "@mui/icons-material/Info";
import { getPasswordStrength } from "./PasswirdStrength";

const EMPTY_VALUES = {
  old_password: "",
  new_password: "",
  confirm_password: "",
};

export default function ChangePassword({
  menuClose,
  handleClose,
  setDialogOpen,
}) {
  const [inputs, setInputs] = useState(EMPTY_VALUES);
  const [loading, setLoading] = useState(false);
  const { setUserInfo, userInfo } = useIds();

  const { enqueueSnackbar } = useSnackbar();
  const [showRequirements, setShowRequirements] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs((old) => ({ ...old, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let error = "";
    const password = inputs.new_password;
    const confirmPassword = inputs.confirm_password;
    let errors = [];
    if (!password) {
      error = "New password is required";
    } else {
      if (password.length < 8) errors.push("At least 8 characters");
      if (!/[A-Z]/.test(password)) errors.push("One uppercase letter (A-Z)");
      if (!/[a-z]/.test(password)) errors.push("One lowercase letter (a-z)");
      if (!/[0-9]/.test(password)) errors.push("One number (0-9)");
      if (!/[^A-Za-z0-9]/.test(password))
        errors.push("One special character (!@#$%^&*)");
      if (errors.length > 0) {
        error = `Password missing: ${errors.join(", ")}`;
      } else if (password !== confirmPassword) {
        error = "New Password and Repeat New Password do not match";
      }
    }

    if (error) {
      enqueueSnackbar(error, { variant: "error" });
      return;
    }

    setLoading(true);
    let data = {
      email: userInfo?.user_id?.email,
      password: password,
      confirm_password: confirmPassword,
    };

    const response = await reset_pop_up_api_for_clients_candidates(data);
    if (response.code === 200) {
      enqueueSnackbar("Password changed successfully", {
        variant: "success",
      });
      handleClose();
      setDialogOpen(false);
      setUserInfo((prev) => {
        const updatedUser = {
          ...prev,
          is_temporary_password: false,
        };
        localStorage.setItem("user", JSON.stringify(updatedUser));
        return updatedUser;
      });

      setInputs(EMPTY_VALUES); // Clear the input fields
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setLoading(false);
    }
    setLoading(false);
  };

  return (
    <form onSubmit={handleSubmit}>
      {/* <CustomMUIInput
        required
        label="Old Password"
        type="password"
        variant="outlined"
        value={inputs.old_password}
        name="old_password"
        onChange={handleChange}
        fullWidth
        size="small"
        autoComplete="new-password"
        is_password={true}
        className={"mb-3"}
      /> */}
      <CustomMUIInput
        required
        label="New Password"
        type="password"
        variant="outlined"
        value={inputs.new_password}
        name="new_password"
        onChange={handleChange}
        fullWidth
        size="small"
        autoComplete="new-password"
        is_password={true}
        className={"mb-1"}
      />
      {/* Password strength progress bar and label with info icon */}
      {inputs.new_password &&
        (() => {
          const { level, color, percentage } = getPasswordStrength(
            inputs.new_password
          );
          return (
            <div style={{ width: "100%", marginBottom: 3 }}>
              <div
                style={{
                  height: 8,
                  borderRadius: 4,
                  background: "#eee",
                  width: "100%",
                  overflow: "hidden",
                  marginBottom: 6,
                }}
              >
                <div
                  style={{
                    height: "100%",
                    width: `${percentage}%`,
                    background: color,
                    transition: "width 0.3s, background 0.3s",
                  }}
                ></div>
              </div>
              {/* Strength label with info icon at the end below the bar */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <span
                  style={{
                    fontWeight: 600,
                    fontSize: 14,
                    color: color,
                    textTransform: "capitalize",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {level}
                  <span
                    style={{
                      marginLeft: 6,
                      cursor: "pointer",
                      verticalAlign: "middle",
                      color: "#1976d2",
                      display: "inline-flex",
                      alignItems: "center",
                    }}
                    onClick={() => setShowRequirements((prev) => !prev)}
                    title="Show password requirements"
                  >
                    <InfoIcon style={{ fontSize: 16, color: "#1976d2" }} />
                  </span>
                </span>
              </div>
            </div>
          );
        })()}
      {/* Password requirements shown on info icon click */}
      {showRequirements && inputs.new_password && (
        <div
          style={{
            background: "#f8f9fa",
            borderRadius: 6,
            padding: "12px 16px",
            marginBottom: 18,
            marginTop: 8,
            boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
          }}
        >
          <strong style={{ fontSize: 14 }}>Password Requirements</strong>
          <ul style={{ fontSize: 13, marginBottom: 0, marginTop: 6 }}>
            <li>At least 8 characters</li>
            <li>One uppercase letter (A-Z)</li>
            <li>One lowercase letter (a-z)</li>
            <li>One number (0-9)</li>
            <li>One special character (!@#$%^&*)</li>
          </ul>
        </div>
      )}
      <CustomMUIInput
        required
        label="Repeat New Password"
        type="password"
        variant="outlined"
        value={inputs.confirm_password}
        name="confirm_password"
        onChange={handleChange}
        fullWidth
        size="small"
        autoComplete="new-password"
        is_password={true}
        className={"mb-3 mt-2"}
      />
      <div className="text-end">
        <button
          type="submit"
          className="theme-button-contained"
          disabled={loading}
        >
          {loading ? "Saving..." : "Save"}
        </button>
      </div>
    </form>
  );
}
